import React from 'react'
import { Chart } from './chart'
import { config } from './config'
import './styles.scss'
interface BaseChartProps {
  line: cantonsDataData[]
  yProp: string
  xDomain: [number, number]
  yDomain: [number, number]
  className: string
  yTicks: { text: number[]; lines: number[] }
  isFirst: boolean
  noData?: boolean
  start: string
}
export const LineOnly: React.FC<BaseChartProps> = ({
  line,
  yProp,
  xDomain,
  yDomain,
  className,
  yTicks,
  isFirst,
  start,
  noData=false
}) => (
  <>
    <Chart
      data={line}
      yProp={yProp}
      xDomain={xDomain}
      yDomain={yDomain}
      className={className}
      yTicks={yTicks}
      isFirst={isFirst}
      start={start}
      noData={noData}
    />
  </>
)
